import {hideOverlay, showOverlay, toggleDropdown, toggleOverlay} from "../blocks";
import {
  cleanFileName,
  convertToISODateFormat,
  convertToItalianFormat,
  isStreamViewPage,
  months,
  isVideoMimeType,
  isAudioMimeType,
  trackEvent
} from "../helpers";
import {Datepicker} from 'flowbite-datepicker';
import videojs from "video.js";
import "video.js/dist/video-js.css";

export let filters = {
  'type-filter': [],
  'category-filter': [],
  'stream-filter': [],
  'start-date-filter': '',
  'end-date-filter': '',
}
export const drupalStreamFilterSelector = 'select[name="stream"]'
export const drupalTypeFilterSelector = 'select[data-drupal-selector="edit-type"]'
export const drupalStartDateFilterSelector = 'input[data-drupal-selector="edit-created-min"]'
export const drupalEndDateFilterSelector = 'input[data-drupal-selector="edit-created-max"]'
export const drupalSortFilterSelector = 'select[name="sort_order"]'
export const drupalApplyFilterSelector = '#drupal-filters-wrapper .form-submit[id*="edit-submit"]'

const $drawer = jQuery('#drawer-details');

let drawerWasClosedDuringPiP = false;


export function injectDataOnDrawer(data) {
  const content = `
    ${buildDrawerHeader(data)}
    ${buildDrawerBody(data)}
  `;

  appendContentToDrawer(content);
  registerDrawerListeners(data);
}

function buildCloseButtons() {
  return `
    <button
        id="close-drawer-desktop-button"
        class="w-11 h-11 bg-white border border-neutral-a100 rounded-full absolute top-6 -left-4 -translate-x-full flex items-center justify-center hover:bg-neutral-200"
        style="box-shadow: 0 8px 24px #1928391F"
    >
        <span class="sr-only">Chiudi dettaglio contenuto</span>
        <img class="w-6 h-6" src="/themes/custom/adoption_management/assets/icons/close-black.svg" alt="">
    </button>
    <div class="md:hidden border-b border-neutral-200">
        <div class="py-3 px-4">
          <button
              id="close-drawer-mobile-button"
              class="w-10 h-10 bg-white flex items-center justify-center"
          >
              <span class="sr-only">Chiudi dettaglio contenuto</span>
              <img class="w-6 h-6" src="/themes/custom/adoption_management/assets/icons/close-black.svg" alt="">
          </button>
        </div>
    </div>
  `;
}

function buildDrawerHeader(data) {
  const isNotice = typeof data.type === 'undefined';

  if(data.type === "q_a") {
    return  `
      <div id="drawer-header" class="px-4 sm:px-8 pt-8 pb-5 flex flex-col">
        <h2 class="font-medium text-[32px] text-jumbo-950">${data?.title}</h2>
        <p class="font-medium text-base text-[#9499A0]">${data?.subtitle}</p>
      </div>
  `;
  }

  let labelClasses = '';
  let labelText = ''
  switch (data.type) {
    case 'documents':
      labelClasses = 'text-green-700 bg-green-a50';
      labelText = 'Documento';
      break;
    case 'report':
      labelClasses = 'text-blue-700 bg-blue-a50';
      labelText = 'Report';
      break;
    case 'media':
      labelClasses = 'text-blue-700 bg-blue-a50';
      labelText = 'Media';
      break;
    default:
      labelClasses = 'text-jumbo-950 bg-jumbo-a50';
      labelText = 'Comunicazioni per te';
      break;
  }

  const label = `
    <span class="text-sm font-semibold py-[2px] px-3 rounded-full h-6 ${labelClasses}">${labelText}</span>
  `;


  let settingsDropdown = '';
  if (ofGlobals.isEditor) {
    settingsDropdown = `
      <div class="dropdown-group relative">
        <button data-target-id="options-drawer-${data.id}" class="dropdown-toggle" type="button">
          <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 4 15">
            <path d="M3.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 6.041a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 5.959a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"/>
          </svg>
        </button>

        <div id="options-drawer-${data.id}" class="dropdown-content hidden" style="box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.12);">
          <ul class="py-2 px-2 text-sm text-gray-700">
            <li class="px-2 rounded-lg">
              <span class="text-xs font-semibold text-jumbo-400">Azioni</span>
            </li>
            <li>
              <a href="/node/${data.id}/edit" class="edit-content px-2 py-2 hover:bg-gray-100 flex items-center w-full font-medium text-sm rounded-lg">
                <span>Modifica</span>
              </a>
            </li>
            <li>
              <a  href="/node/${data.id}/delete"  class="delete-content px-2 py-2 hover:bg-gray-100 flex items-center w-full font-medium text-sm rounded-lg">
                <span class="text-red-600">Elimina</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    `
  }

  const buttons = `
    <div class="flex items-center gap-3">
      <a
        href="${data.fileDrupal}"
        download="${cleanFileName(data.title)}"
        target="_blank"
        id="document-download"
        class="bg-jumbo-950 text-white rounded-lg font-semibold text-base py-3 px-5 whitespace-nowrap flex ${isNotice ? 'hidden' : ''}"
      >
        <span>Scarica</span>
        <img class="w-5 h-5 inline-block ml-2" src="/themes/custom/adoption_management/assets/icons/download-white.svg" alt="">
      </a>
       ${settingsDropdown}
    </div>
  `

  return `
    <div id="drawer-header" class="px-4 sm:px-8 pt-8 pb-5 flex justify-between items-center">
       ${label}
       ${buttons}
    </div>
  `;
}

function buildDrawerBody(data) {
  const isNotice = typeof data.type === 'undefined';
  if(data.type === "q_a") {
    let qaAccordions = "";
    const accordions = data.qa_items || [];
    for (const a of accordions) {
      qaAccordions+=`
        <div class="qa-accordion-item">
          <a class="qa-accordion-title flex justify-between select-none cursor-pointer font-semibold text-base py-8">
            ${a?.question}
          <img width="24"height="24" class="chevron" src="/themes/custom/adoption_management/assets/icons/chevron-down.svg" alt="chevron">
          </a>
          <p class="qa-accordion-content font-normal text-sm text-[#3F4550] pb-8">
            ${a?.answer}
          </p>
        </div>
        <hr>
      `;
    }
    return  `
      <div id="drawer-body" class="px-4 py-8 sm:p-8">
        ${qaAccordions}
      </div>
  `;
  }
  let dateString = '';
  let date = new Date(Number(data.created + '000'));
  if (date) {
    dateString = `
      Pubblicato il ${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}, ${date.getHours()}:${date.getMinutes()}
    `
  }

  let streamRow = '';
  let categoriesRow = ''
  if (!isNotice && typeof data.categoria_processo === 'object' && Object.keys(data.categoria_processo).length > 0) {
    const streamKeys = Object.keys(data.categoria_processo).join(', ');
    streamRow = buildRow('Stream', streamKeys);

    const categoriesKeys = []

    for (const stream in data.categoria_processo) {
      if (data.categoria_processo[stream].length > 0) {
        categoriesKeys.push(...data.categoria_processo[stream])
      }
    }

    if (categoriesKeys.length > 0) {
      const categories = categoriesKeys.join(', ')
      categoriesRow = buildRow('Categorie', categories);
    }
  }

  let tagRow = ''
  if (data.tag && !isNotice) tagRow = buildRow('Tag', data.tag)

  let tabAI = '';
  let tabUpdates = '';
  if (!isNotice && ofGlobals.isEditor) {
    tabAI = buildTab('Alimenta la knowledge del Virtual Agent', data.knowledge)
    tabUpdates = buildTab('Update automatici', data.updates)
  }

  let downloadSection = '';
  if (data.fileDrupal && !isNotice) {
    if (isVideoMimeType(data.fileMimeType)) {
      downloadSection = `
        <div class="flex items-center gap-4">
            <video
              id="document-video"
              class="video-js"
              controls
              preload="auto"
              data-setup="{}"
            >
              <source src="${data.fileDrupal}" type="${data.fileMimeType}" />
            </video>
        </div>
        `;
    } else if (isAudioMimeType(data.fileMimeType)) {
      downloadSection = `
        <audio id="document-audio" controls>
            <source src="${data.fileDrupal}" type="${data.fileMimeType}">
            Il tuo browser non supporta l'elemento audio.
        </audio>
        `;
    } else {
      let fileName = data.fileDrupal.split('/').pop();
      if (!fileName) fileName = data.title

      let fileMimeType = getCorrectFileImageByFileMimeType(data.fileMimeType)

      fileName = decodeURIComponent(fileName);
      downloadSection = `
      <div class="flex items-center gap-4">
         <img class="basis-12 w-16 h-16" src="${fileMimeType}" alt="">
         <div class="w-full">
            <span class="text-base text-jumbo-950 font-semibold break-words break-all">${fileName}</span>
         </div>
      </div>
    `
    }
  }

  return `
    <div id="drawer-body" class="px-4 py-8 sm:p-8">
        <span class="block text-sm text-neutral-950 mb-4">${dateString}</span>
        <h3 class="break-words overflow-hidden text-2xl text-jumbo-950 font medium mb-2 lg:text-3xl">${data.title}</h3>
        <p class="break-words overflow-hidden text-base text-neutral-950">${data.body ? data.body : ''}</p>

        <div class="pt-10"></div>

        ${streamRow}
        ${categoriesRow}
        ${tagRow}

        <div class="pt-5"></div>

        ${tabAI}
        ${tabUpdates}

        <div class="pt-5"></div>

        <h4 class="text-lg text-jumbo-950 font-medium mb-6 ${isNotice ? 'hidden' : ''}">${data.type === 'media' ? 'Media' : 'Allegato'}</h4>

        ${downloadSection}

    </div>
  `;
}

export function openDrawer() {
  $drawer.removeClass('hidden');
  showOverlay();
  appendDrawerLoader();
  registerPreviewDrawerListeners();
}

function appendDrawerLoader() {
  const loader = `
    <div id="loader-container" class="w-full flex justify-center items-center h-full">
      <div role="status">
          <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin fill-pink-400" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
          </svg>
          <span class="sr-only">Loading...</span>
      </div>
    </div>
  `

  const content = `
    <div id="drawer-append-target" class="h-full">
      ${buildCloseButtons()}
      <div id="drawer-loader"></div>
      ${loader}
    </div>
  `

  $drawer.html('');
  $drawer.append(content);
}

export function closeDrawer() {
  const video = document.getElementById("document-video");

  if (video) {drawerWasClosedDuringPiP = true;}

  $drawer.addClass('hidden');
  hideOverlay();
  $drawer.html('');
}

function appendContentToDrawer(content) {
  jQuery('#loader-container').remove();
  jQuery('#drawer-append-target').append(content);
}


function registerPreviewDrawerListeners() {
  jQuery('#close-drawer-desktop-button, #close-drawer-mobile-button', $drawer).on('click', function () {
    closeDrawer();
    for (const filter in filters) {
      filters[filter] = []
    }
  })
}

function registerDrawerListeners(data) {
  jQuery('.dropdown-toggle', $drawer).on('click', function () {
    toggleDropdown(this);
  })
  if(data) {
    if(isVideoMimeType(data.fileMimeType)) {
      const videoElement = document.getElementById("document-video");
      videoElement.addEventListener("loadedmetadata", () => {
      const player = videojs(videoElement, {
        controls: true,
        autoplay: false,
        preload: "auto",
        fluid: true
      });

      registerPiPHandlers(videoElement, player, data);
      });
    }

    jQuery('#document-download').click(function (){
      trackEvent("DOCUMENT_DOWNLOAD", data.title).finally(() => {});
    });

    jQuery(".qa-accordion-title").on("click", function (e) {
      e.preventDefault();
      const title = jQuery(this); // get the current item title of the accordion
      const chevron = title.find(".chevron"); // find the chevron
      const content = jQuery(this).next(".qa-accordion-content"); // get the item content
      jQuery(".qa-accordion-content").not(content).slideUp(200); // close all the other item except the one clicked
      jQuery(".qa-accordion-title").not(title).removeClass("text-pink-400"); // remove all the active item class
      jQuery(".qa-accordion-title").not(title).find(".chevron").removeClass("rotate-180 qa-chevron-active"); // remove all the active item class
      content.stop(true, true).slideToggle(200); // stop the animation of the current elemnt and toggle 
      jQuery(this).toggleClass("text-pink-400"); // set the active class on title
      chevron.toggleClass("rotate-180 qa-chevron-active"); // rotate chevron and set active
    });

  }
}

function buildRow(title = '', values = '') {
  return `
    <div class="flex pb-4 border-b border-neutral-300 mb-6">
      <span class="basis-1/2 font-medium text-basis text-neutral-950">${title}</span>
      <span class="basis-1/2 font-medium text-basis text-neutral-950">${values}</span>
    </div>
  `
}

function buildTab(title = '', isActive = false) {
  const chipDisabled = `
    <span class="text-xs font-semibold text-jumbo-950 px-2 bg-jumbo-a50 rounded-full h-5">Inattivo</span>
  `
  const chipActive = `
    <span class="text-xs font-semibold text-green-700 px-2 bg-green-a50 rounded-full h-5">Attivo</span>
  `
  return `
    <div class="flex items-center justify-between p-4 border border-neutral-300 mb-6 rounded-lg">
      <span class="font-semibold text-basis text-neutral-950 pr-4">${title}</span>
      ${isActive ? chipActive : chipDisabled}
    </div>
  `
}

export function injectFiltersOnDrawer() {
  const content = `
    ${buildFiltersHeader()}
    <div class="flex flex-col h-full justify-between" id="drawer-filters-body">
      ${buildFiltersBody()}
      ${buildFiltersFooter()}
    </div>
  `;

  appendContentToDrawer(content)
  registerDrawerListeners();
  registerFiltersListeners();
  populateSelectedFilters();
}

function buildFiltersHeader() {
  return `
    <div id="drawer-header" class="px-4 sm:px-8 pt-8 pb-5 flex justify-between items-center">
        <h2 class="text-3xl font-medium text-jumbo-950">Filtri</h2>
    </div>
  `
}

function buildFiltersBody() {
  const dateFilter = `
    ${buildFilterTitleHTML('Seleziona un periodo')}
    ${buildDateInput({id: 'start-date-filter', label: 'Inizio'})}
    ${buildDateInput({id: 'end-date-filter', label: 'Fine'})}
  `

  const typeList = [
    {name: 'Documenti', value: 'documents'},
    {name: 'Report', value: 'report'},
    {name: 'Media', value: 'media'},
  ];

  const typeFilter = `
    ${buildFilterTitleHTML('Seleziona una tipologia di documento')}
    ${buildChipFilter({options: typeList, target: 'type-filter'})}
  `;

  const streamList = getStreamList();

  const streamFilter = `
    ${buildFilterTitleHTML('Seleziona lo stream')}
    ${buildChipFilter({options: streamList, target: 'stream-filter'})}
  `
  const categoryFilter = `
      ${buildFilterTitleHTML('Seleziona la categoria')}
      <div id="category-filter-wrapper">
        ${printCategoryFilterPlaceholder()}
      </div>
  `

  return `
    <div id="drawer-body" class="px-4 py-8 sm:p-8">
        ${dateFilter}
        ${printFilterDivider()}
        ${typeFilter}
        ${printFilterDivider()}
        <div id="stream-filter-wrapper" class="${isStreamViewPage() ? 'hidden' : ''}">
          ${streamFilter}
          ${printFilterDivider()}
        </div>
        ${categoryFilter}
    </div>
  `
}

function buildFilterTitleHTML(title) {
  return `<h3 class="text-lg font-medium text-neutral-950 mb-4">${title}</h3>`
}

function buildDateInput({id = '', label = ''}) {
  let labelHTML;
  if (label) {
    labelHTML = `
    <label class="block text-neutral-950 text-sm font-semibold mb-2">${label}</label>
    `
  }
  return `
    ${labelHTML}
    <div class="relative mb-4">
      <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
        <svg class="w-4 h-4 text-gray-500 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
          <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"/>
        </svg>
      </div>
      <input id="${id}" type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5" placeholder="Scegli la data">
    </div>
  `;
}

function getStreamList() {
  let streamList = [];
  jQuery(drupalStreamFilterSelector + ' option').each(function () {
    const name = jQuery(this).text();
    const value = jQuery(this).val();

    if (name && name[0] !== '-') {
      streamList.push({name, value});
    }
  });

  return streamList;
}

function buildChipFilter({options = [], target = ''}) {
  if (!options) return '';
  const chips = [];

  options.forEach((el) => {
    let icon = '';
    switch (el.value) {
      case 'documents':
        icon = `
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.8333 2.75V6.41667C12.8333 6.65978 12.9299 6.89294 13.1018 7.06485C13.2737 7.23676 13.5069 7.33333 13.75 7.33333H17.4167" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M15.5833 19.25H6.41668C5.93045 19.25 5.46413 19.0568 5.12031 18.713C4.7765 18.3692 4.58334 17.9029 4.58334 17.4167V4.58333C4.58334 4.0971 4.7765 3.63079 5.12031 3.28697C5.46413 2.94315 5.93045 2.75 6.41668 2.75H12.8333L17.4167 7.33333V17.4167C17.4167 17.9029 17.2235 18.3692 16.8797 18.713C16.5359 19.0568 16.0696 19.25 15.5833 19.25Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        `
        break;
      case 'report':
        icon = `
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.8333 2.75V6.41667C12.8333 6.65978 12.9299 6.89294 13.1018 7.06485C13.2737 7.23676 13.5069 7.33333 13.75 7.33333H17.4167" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M15.5833 19.25H6.41668C5.93045 19.25 5.46413 19.0568 5.12031 18.713C4.7765 18.3692 4.58334 17.9029 4.58334 17.4167V4.58333C4.58334 4.0971 4.7765 3.63079 5.12031 3.28697C5.46413 2.94315 5.93045 2.75 6.41668 2.75H12.8333L17.4167 7.33333V17.4167C17.4167 17.9029 17.2235 18.3692 16.8797 18.713C16.5359 19.0568 16.0696 19.25 15.5833 19.25Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.25 15.5833V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11 15.5827V14.666" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M13.75 15.584V12.834" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        `
        break;
      case 'media':
        icon = `
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.25 13.75H5.5C4.77065 13.75 4.07118 13.4603 3.55546 12.9445C3.03973 12.4288 2.75 11.7293 2.75 11V5.5C2.75 4.77065 3.03973 4.07118 3.55546 3.55546C4.07118 3.03973 4.77065 2.75 5.5 2.75H11C11.7293 2.75 12.4288 3.03973 12.9445 3.55546C13.4603 4.07118 13.75 4.77065 13.75 5.5V8.25" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.25 11C8.25 10.2707 8.53973 9.57118 9.05546 9.05546C9.57118 8.53973 10.2707 8.25 11 8.25H16.5C17.2293 8.25 17.9288 8.53973 18.4445 9.05546C18.9603 9.57118 19.25 10.2707 19.25 11V16.5C19.25 17.2293 18.9603 17.9288 18.4445 18.4445C17.9288 18.9603 17.2293 19.25 16.5 19.25H11C10.2707 19.25 9.57118 18.9603 9.05546 18.4445C8.53973 17.9288 8.25 17.2293 8.25 16.5V11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2.75 10.9996L4.85467 8.89498C5.26896 8.48075 5.83082 8.24805 6.41667 8.24805C7.00252 8.24805 7.56438 8.48075 7.97867 8.89498L8.25 9.16631" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12.8333 12.375V15.125L15.125 13.75L12.8333 12.375Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6.41666 5.5V5.50917" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        `
        break;
    }

    const chip = `
      <button type="button" data-filter-value="${el.value}" data-filter-group="${target}" class="chip-filter px-5 py-3 text-jumbo-950 text-base font-medium border border-neutral-400 rounded-full transition flex items-center gap-2">
        ${el.name}
        ${icon}
      </button>
    `
    chips.push(chip)
  })

  return `
    <div class="flex flex-wrap gap-4" id="${target}">
        ${chips.join('')}
    </div>
  `
}

function printFilterDivider() {
  return `<div class="my-5 md:my-8 border-t border-neutral-400 w-full"></div>`
}

function printCategoryFilterPlaceholder() {
  return `<span id="category-placeholder">Seleziona stream per visualizzare categorie correlate</span>`
}

function registerFiltersListeners() {
  const startFilterInput = document.getElementById('start-date-filter');
  const endFilterInput = document.getElementById('end-date-filter');

  Datepicker.locales.it = {
    days: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
    daysShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
    daysMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
    months: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
    monthsShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
    today: "Oggi",
    monthsTitle: "Mesi",
    clear: "Cancella",
    weekStart: 1,
    format: "dd/mm/yyyy"
  }

  const startDp = new Datepicker(startFilterInput, {
    language: 'it',
  });
  const endDp = new Datepicker(endFilterInput, {
    language: 'it'
  });

  jQuery('#drawer-filters-body').on('click', '.chip-filter', function () {
    onClickChipFilter(this)
  })

  jQuery('#reset-filters').on('click', function () {
    resetFilters();
  })

  jQuery('#apply-filters').on('click', function () {
    applyFilters()
  })
}

function onClickChipFilter(button) {
  const value = jQuery(button).data('filter-value');
  const filterGroup = jQuery(button).data('filter-group');
  if (filters[filterGroup] && filters[filterGroup].includes(value)) {
    filters[filterGroup] = filters[filterGroup].filter((el) => el !== value);
    jQuery(button).removeClass('active')
    return;
  } else {
    filters[filterGroup] = [value]
  }
  if (filterGroup === 'stream-filter') {
    filters['category-filter'] = [];
    appendCategoryFilter(value);
  }
  jQuery(`.chip-filter[data-filter-group="${filterGroup}"]`).removeClass('active');
  jQuery(button).addClass('active');
}

function appendCategoryFilter(value = '') {
  const categoriesList = getCategoriesFromStream(value);
  let content = 'Nessuna categoria associata allo stream selezionato.'
  if (categoriesList && categoriesList.length > 0) {
    content = buildChipFilter({options: categoriesList, target: 'category-filter'})
  }
  jQuery('#category-filter-wrapper').html(content)
}

function getCategoriesFromStream(value = '') {
  let categories = [];
  const options = document.querySelectorAll(drupalStreamFilterSelector + ' option');
  if (!options) return [];

  let startIndex;
  let endIndex;
  for (let i = 0; i < options.length; i++) {
    const option = options[i];
    if (jQuery(option).val() == value) {
      startIndex = i;
      continue;
    }
    if (startIndex && jQuery(option).text()[0] !== '-') {
      endIndex = i;
      break;
    }
  }
  if (typeof endIndex === 'undefined') endIndex = options.length

  if (startIndex && endIndex) {
    for (let i = startIndex + 1; i < endIndex; i++) {
      const option = options[i];
      categories.push({
        name: option.textContent.slice(1),
        value: option.value
      })
    }
  }

  return categories;
}

function buildFiltersFooter() {
  return `
    <div class="pt-4 pb-5 px-5 border-t border-neutral-400 flex justify-end gap-4">
        <button type="button" class="secondary-btn" id="reset-filters">Cancella</button>
        <button type="button" class="primary-btn" id="apply-filters">Applica</button>
    </div>
  `
}

function applyFilters() {
  if (Object.keys(filters).length === 0) return;
  filters['start-date-filter'] = jQuery('#start-date-filter').val();
  filters['end-date-filter'] = jQuery('#end-date-filter').val();
  for (const filter in filters) {
    if (filter.length === 0) continue;
    if (filter === 'stream-filter' && filters['category-filter'].length > 0) continue;
    let value = '';
    if (Array.isArray(filters[filter])) {
      value = filters[filter][0];
    } else {
      value = filters[filter]
    }

    switch (filter) {
      case 'type-filter':
        jQuery(drupalTypeFilterSelector).val(value)
        break;
      case 'category-filter':
      case 'stream-filter':
        jQuery(drupalStreamFilterSelector).val(value)
        break;
      case 'start-date-filter':
        jQuery(drupalStartDateFilterSelector).val(convertToISODateFormat(value))
        break;
      case 'end-date-filter':
        jQuery(drupalEndDateFilterSelector).val(convertToISODateFormat(value))
        break;
    }
  }

  jQuery(drupalApplyFilterSelector).click();
}

export function resetFilters(enableReload = false) {
  const streamFilterValue = filters['stream-filter']
  filters = {
    'type-filter': [],
    'category-filter': [],
    'stream-filter': isStreamViewPage() ? streamFilterValue : [],
    'start-date-filter': '',
    'end-date-filter': '',
  }
  populateSelectedFilters()
  jQuery('.chip-filter').removeClass('active')
  jQuery('#start-date-filter').val('')
  jQuery('#end-date-filter').val('')
  if (isStreamViewPage()) {
    jQuery('.chip-filter[data-filter-group="category-filter"]').removeClass('active')
  } else {
    jQuery('#category-filter-wrapper').html(printCategoryFilterPlaceholder())
  }

  if (enableReload) applyFilters();
}

function populateSelectedFilters() {
  if (filters['start-date-filter']) jQuery('#start-date-filter').val(convertToItalianFormat(filters['start-date-filter']))
  if (filters['end-date-filter']) jQuery('#end-date-filter').val(convertToItalianFormat(filters['end-date-filter']))
  if (filters['type-filter'].length > 0) {
    const value = filters['type-filter'][0];
    jQuery(`.chip-filter[data-filter-group="type-filter"][data-filter-value="${value}"]`).addClass('active')
  }
  if (filters['stream-filter'].length > 0) {
    const value = filters['stream-filter'][0];
    jQuery(`.chip-filter[data-filter-group="stream-filter"][data-filter-value="${value}"]`).addClass('active')
    appendCategoryFilter(value);
  }
  if (filters['category-filter'].length > 0) {
    const value = filters['category-filter'][0];
    jQuery(`.chip-filter[data-filter-group="category-filter"][data-filter-value="${value}"]`).addClass('active')
  }
}

function registerPiPHandlers(videoElement, player, data) {

  //close PiP
  videoElement.addEventListener("leavepictureinpicture", async (e) => {
    setTimeout(() => {
      if (!e.target) {
        const isPaused = player.paused();
        const volumeLevel = player.volume();
        const currentTime = player.currentTime();
        const isMuted = player.muted();
        player.dispose();
      }
    },0)
  });
}

function getCorrectFileImageByFileMimeType(fileMimeType) {
  switch (fileMimeType) {
    case 'text/plain':
      return '/themes/custom/adoption_management/assets/icons/file_type_txt.svg';
    case 'application/pdf':
      return '/themes/custom/adoption_management/assets/icons/file_type_pdf.svg';
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return '/themes/custom/adoption_management/assets/icons/file_type_docx.svg'
    case 'image/jpeg':
      return '/themes/custom/adoption_management/assets/icons/file_type_jpeg.svg'
    case 'image/jpg':
      return '/themes/custom/adoption_management/assets/icons/file_type_jpg.svg'
    case 'image/png':
      return '/themes/custom/adoption_management/assets/icons/file_type_png.svg'
    case 'audio/mpeg':
      return '/themes/custom/adoption_management/assets/icons/file_type_mp3.svg'
    case 'audio/wav':
      return '/themes/custom/adoption_management/assets/icons/file_type_wav.svg'
    case 'video/mp4':
      return '/themes/custom/adoption_management/assets/icons/file_type_mp4.svg'
    case 'video/x-matroska':
      return '/themes/custom/adoption_management/assets/icons/file_type_mkv.svg'
    case 'application/msword':
      return '/themes/custom/adoption_management/assets/icons/file_type_doc.svg'
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      return '/themes/custom/adoption_management/assets/icons/file_type_pptx.svg'
    case 'application/vnd.ms-powerpoint':
      return '/themes/custom/adoption_management/assets/icons/file_type_ppt.svg'
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return '/themes/custom/adoption_management/assets/icons/file_type_xlsx.svg'
    case 'application/vnd.ms-excel':
      return '/themes/custom/adoption_management/assets/icons/file_type_xls.svg'
    default:
      return '/themes/custom/adoption_management/assets/icons/type-document-icon.svg'
    }

}
